import React from 'react';
import './ShapeToolbar.css';

const SHAPE_TYPES = {
  RECTANGLE: 'rectangle',
  CIRCLE: 'circle',
  ARROW: 'arrow',
  LINE: 'line',
  HIGHLIGHT: 'highlight'
};

const COLORS = [
  { name: 'Red', value: '#FF6B6B' },
  { name: 'Blue', value: '#4ECDC4' },
  { name: 'Green', value: '#95E1D3' },
  { name: 'Yellow', value: '#FCE38A' },
  { name: 'Orange', value: '#F38181' },
  { name: 'Purple', value: '#AA96DA' }
];

const ShapeToolbar = ({ 
  selectedShape, 
  onShapeSelect, 
  selectedColor, 
  onColorSelect,
  isDrawing,
  onClear 
}) => {
  return (
    <div className="shape-toolbar">
      <div className="toolbar-section">
        <label>Shapes:</label>
        <div className="shape-buttons">
          <button
            className={`shape-btn ${selectedShape === SHAPE_TYPES.RECTANGLE ? 'active' : ''}`}
            onClick={() => onShapeSelect(SHAPE_TYPES.RECTANGLE)}
            title="Rectangle"
          >
            ▭
          </button>
          <button
            className={`shape-btn ${selectedShape === SHAPE_TYPES.CIRCLE ? 'active' : ''}`}
            onClick={() => onShapeSelect(SHAPE_TYPES.CIRCLE)}
            title="Circle"
          >
            ○
          </button>
          <button
            className={`shape-btn ${selectedShape === SHAPE_TYPES.ARROW ? 'active' : ''}`}
            onClick={() => onShapeSelect(SHAPE_TYPES.ARROW)}
            title="Arrow"
          >
            →
          </button>
          <button
            className={`shape-btn ${selectedShape === SHAPE_TYPES.LINE ? 'active' : ''}`}
            onClick={() => onShapeSelect(SHAPE_TYPES.LINE)}
            title="Line"
          >
            ─
          </button>
          <button
            className={`shape-btn ${selectedShape === SHAPE_TYPES.HIGHLIGHT ? 'active' : ''}`}
            onClick={() => onShapeSelect(SHAPE_TYPES.HIGHLIGHT)}
            title="Highlight"
          >
            ═
          </button>
        </div>
      </div>

      <div className="toolbar-section">
        <label>Color:</label>
        <div className="color-picker">
          {COLORS.map(color => (
            <button
              key={color.value}
              className={`color-btn ${selectedColor === color.value ? 'active' : ''}`}
              style={{ backgroundColor: color.value }}
              onClick={() => onColorSelect(color.value)}
              title={color.name}
            />
          ))}
        </div>
      </div>

      {isDrawing && (
        <button className="clear-btn" onClick={onClear}>
          Cancel Drawing
        </button>
      )}
    </div>
  );
};

export default ShapeToolbar;
export { SHAPE_TYPES, COLORS };




